import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


const NewspaperPublication = () => {
  const pageid = 5; // <-- static pageid for this section (set from backend)
  const [title, setTitle] = useState("");
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch API data
  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setNotices([]);
          setLoading(false);
          return;
        }

        // Title from API
        setTitle(result.page_title || "Newspaper Publication of Notices");

        // Map notices
        const mapped = result.data.map((item) => ({
          label: item.pdf_name,
          file: item.upload_file_path,
        }));

        setNotices(mapped);
      } catch (error) {
        console.error("Fetch failed:", error);
        setNotices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, []);

  return (
    <>
      <Helmet>
        <title>{title} | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative w-full">
        <img
          src="./imgs/investors/investornewspaperpublicationofnotice.png"
          alt="Chiripal Group Banner"
          className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center">
          <div className="px-4 sm:px-8 md:px-16 lg:px-32">
            <h1 className="text-white text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
              {title}
            </h1>
          </div>
        </div>
      </div>

      {/* PDF Section */}
      <div className="py-12 px-4 font-signika max-w-7xl mx-auto">
        {loading ? (
          <p>Loading newspaper publications...</p>
        ) : notices.length === 0 ? (
          <p>No notices found.</p>
        ) : (
          <div className="mb-12">
            <h2 className="text-xl font-extrabold text-[#0b3a6a] mb-4">
              {title}
            </h2>
            <ul className="list-disc pl-6 space-y-2 text-[#0b3a6a]">
              {notices.map((item, idx) => (
                <li key={idx}>
                  <a
                    href={`${API_PDF_URL}/${item.file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default NewspaperPublication;
